import {
  BackgroundColorInterface,
  BackgroundImageInterface,
  BackgroundStylesInterface,
} from 'common/types/background-interfaces'
import { ContentWidthEnum, PaddingType } from 'common/types/styleTypes'
import React, { ReactNode } from 'react'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import { WebsiteFooterBackgroundUi } from './ui/website-footer-background-ui'
import { WebsiteFooterWrapper } from './ui/website-footer-wrapper'

export interface CommonWebsiteFooterProps
  extends BackgroundColorInterface,
    BackgroundImageInterface,
    BorderEntityInterface {
  htmlAttrId: string
  children: ReactNode
  background?: BackgroundStylesInterface
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  contentWidth?: ContentWidthEnum
}

export const CommonWebsiteFooter = ({
  htmlAttrId,
  children,
  background,
  backgroundImage,
  backgroundColor,
  border,
  mobileBorder,
  ...rest
}: CommonWebsiteFooterProps) => (
  <WebsiteFooterBackgroundUi
    background={background}
    backgroundImage={backgroundImage}
    backgroundColor={backgroundColor}
    border={border}
    mobileBorder={mobileBorder}
  >
    <WebsiteFooterWrapper {...rest} id={htmlAttrId}>
      {children}
    </WebsiteFooterWrapper>
  </WebsiteFooterBackgroundUi>
)
